export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  SIGNUP: "/signup",
  SEARCH: "/search",
  CREATE: "/create",
  BLOGS_BY_TAG: "/tag/:tagName",
  PROFILE: "/profile/:userId",
  BLOG: "/blog/:blogId",
  EDIT_BLOG: "/blog/:blogId/edit",
};
